import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {map} from 'rxjs/operators';
import {catchError} from "rxjs/operators";

declare var BACKENDPATH: any;
declare var CANTORVERSION: any;
declare var DobryKantor: any;

export class ValidationError {
    public messageId: number;
    public error: string;
    public errors: string[];
    public notAuthorized: boolean;
}

@Injectable()
export class HttpService {
    backendPath: string;

    constructor(private httpClient: HttpClient) {
        this.backendPath = '';

        if (BACKENDPATH) {
            this.backendPath = BACKENDPATH;
        }
    }

    post(url: string, data: any): Observable<boolean> {
        return this.httpClient
            .post(this.buildUrl(url), data, {
                withCredentials: true
            })
            .pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    get(url: string, search: any = null): Observable<any> {
        let params = new HttpParams();

        if (search) {
            for(let key in search) {
                if ((typeof search[key] !== 'undefined') && (search[key] != null)) {
                    params = params.set(key, search[key]);
                }
            }
        }

        return this.httpClient.get(this.buildUrl(url), {
                withCredentials: true,
                params: params
            })
            .pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    private extractData(res: any) {
        // console.log(JSON.stringify(res));
        if (!res.success) {
            let error = new ValidationError();

            if (res.messageId) {
                error.messageId = res.messageId;
            }

            if (res.notAuthorized) {
                error.notAuthorized = res.notAuthorized;
            }

            if (res.errors) {
                error.error = res.errors[0];
                error.errors = res.errors;
            }

            throw error;
        }

        return res.data;
    }

    private handleError (error: any) {
        if (!(error instanceof ValidationError)) {
            // In a real world app, we might use a remote logging infrastructure
            // We'd also dig deeper into the error to get a better message
            let errMsg = (error.message) ? error.message :
                error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            console.error(errMsg); // log to console instead

            return throwError(errMsg);
        }

        if (error instanceof ValidationError) {
            if (error.notAuthorized) {
                if (CANTORVERSION !== 'expert') {
                    window.location.href = '/logowanie.html?sessionState=1&return=' + window.location.pathname;
                } else {
                    location.href = DobryKantor.params.cantor.topUrl + '/logowanie?sessionState=1&return=' + window.location.pathname;
                }
            }
        }

        return throwError(error);
    }

    private buildUrl(url: string) {
        if (!this.backendPath) {
            return url;
        }

        if (!url.startsWith('/')) {
            url = '/' + url;
        }

        return this.backendPath + url;
    }
}
